// @ts-check
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import MapIdFields, {
  useIdentifierFields,
} from '../../../../components/MapFields/MapIdFields';
import { ProgressIndicator, fieldsToImport, useLink } from './_config';

export default function IdentifyFields({ match }) {
  const props = useIdentifierFields({
    workspaceId: match.params.workspaceId,
    importId: match.params.importId,
    fieldsToImport,
  });

  if (props.loading) return null;
  return <IdentifyFieldsContent props={props} />;
}
function IdentifyFieldsContent({ props }) {
  const link = useLink('identifyFields');
  const history = useHistory();

  const valid = Boolean(
    props?.bottlebooksFieldsMap?.['product.productExternalId']?.importFieldName
  );
  return (
    <Layout>
      <ProgressIndicator step="identifyFields" />
      <PageHeader>
        <PageTitle>
          <Trans>Choose your Product ID column</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>Select the column representing your unique product ID.</Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <MapIdFields {...props} />
      </Main>
      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />

        <NextButton
          onClick={async () => {
            const result = await props.updateIdentifierMapping();
            if (!result?.error) history.push(link.next());
          }}
          disabled={!props.isValid || !valid}
        />
      </Footer>
    </Layout>
  );
}
